module.exports = __webpack_public_path__ + "static/OpenTable-482eb1b476f233ba0815e5ec7c9f250f.jpg";